<template>
  <div class="login-container">
    <b-container class="h-100 d-flex align-items-center justify-content-center">
      <b-card class="login-card">
        <div class="mt-1 text-center">
          <b-link :to="{ name: 'Login' }">
            <img class="mb-1" :src="this.appLogoImage" img-fluid width="250" />
          </b-link>
        </div>

        <b-card-title title-tag="h2" class="font-weight-bolder text-center mt-2">
          Welcome to {{ appName }} Portal.
        </b-card-title>
        <b-card-text class="text-center text-muted" style="font-size: 0.9rem">
          Please enter your credentials to access the portal.
        </b-card-text>

        <validation-observer ref="loginFormValidation">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <b-form-group label-for="username">
              <validation-provider #default="{ errors }" name="Username" rules="required">
                <b-form-input
                  id="username"
                  v-model="username"
                  :state="errors.length > 0 ? false : null"
                  name="username"
                  placeholder="Username"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label-for="password" class="mt-2">
              <validation-provider #default="{ errors }" name="Password" rules="required">
                <b-input-group :class="errors.length > 0 ? 'is-invalid' : ''">
                  <b-form-input
                    id="password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="password"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div class="text-right">
              <b-link :to="{ name: 'ForgotPassword' }" class="text-primary small">
                Forgot password?
              </b-link>
            </div>

            <b-button type="submit" variant="loginBtn" class="loginBtn mt-3" block @click="validateForm">
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { $themeConfig } from "@themeConfig";
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, util],
  data() {
    return {
      appName: "",
      appFullName: "",
      password: "",
      username: "",
      required,
    };
  },
  created() {
    this.appName = $themeConfig.app.appName;
    this.appFullName = $themeConfig.app.appFullName;
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
  methods: {
    ...mapActions({ login: "appData/login" }),
    async validateForm() {
      const success = await this.$refs.loginFormValidation.validate();
      if (success) {
        this.submit();
      }
    },
    async submit() {
      try {
        const res = await this.login({
          username: this.username,
          password: this.password,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Logged in successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          console.log("res.data.user.role_data.code_name", );
          if (res.data.user.initial_reset) {
            if(res.data.user.role_data.code_name != 'eo'){
              this.$router.push({ name: "Dashboard" });
            }
            else
            {
              this.$router.push({ name: "BuildingEmergencyState" });
            }
          } else {
            this.$router.push({ name: "ChangePassword" });
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    ...mapGetters({ hasRole: "appData/hasRole" }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style scoped>
/* Ensures full height and vertical centering */
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid lightgrey;
  background: white;
}

.loginBtn {
  background-color: #febc03;
  color: black;
}
</style>
